__turbopack_context__.v({
  "list": "Handling-module-scss-module__AlWtha__list",
  "root": "Handling-module-scss-module__AlWtha__root",
});
